module.exports = __webpack_public_path__ + "static/img/Test.044dfd92.svg";